import React from 'react'

function Choosegroup() {
    return (
        <div className="choose-group">
            <h1>Welcome to <span className= "maroon-text">SuperChat!</span></h1>
            <div className = "chat-rules">
            <h2>Choose a group from the sidebar to chat</h2>
                <ul>
                    <li>No bullying, sexism, racism, homophobia or other hate-based chat </li>
                    <li>Don’t spam words or use all-caps </li>
                    <li>No spoilers to a game, TV show or film </li>
                    <li>Don’t argue with people over chat — especially the moderators </li>
                    <li>Use the language(s) spoken by the broadcaster (so they can reply to what you are saying and other people in chat can understand the conversation) </li>
                    <li>No advertising or self-promotion </li>
                </ul>
            </div>
        </div>
    )
}

export default Choosegroup
